import dynamicSettingsFieldComponentUrl from './dynamicSettingsFieldComponent.html';

class DynamicSettingsFieldComponentCtrl {
  constructor(LaborUISchema, Utils) {
    'ngInject';

    Object.assign(this, { LaborUISchema, Utils });
  }

  getInputWithLabel() {
    if (this.data.inputWithLabel.isExpression) {
      return {
        ...this.data.inputWithLabel,
        value: this.Utils.evaluateExpression(this.data.inputWithLabel.value),
      };
    }

    return this.data.inputWithLabel;
  }
}

export default {
  templateUrl: dynamicSettingsFieldComponentUrl,
  controllerAs: 'ctrl',
  controller: DynamicSettingsFieldComponentCtrl,
  bindings: {
    data: '<',
    settings: '<',
  },
};
